import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function CollapsibleRightPanel({
  title = "Stats",
  children,
  defaultCollapsed = true,
  className = "w-full md:w-[33%] bg-[#1b1b1b]",
  collapsedClassName = "w-full md:w-[52px] bg-[#1b1b1b]",
  onCollapsedChange,
}) {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const updateCollapsed = (nextValue) => {
    setIsCollapsed(nextValue);
    if (typeof onCollapsedChange === "function") {
      onCollapsedChange(nextValue);
    }
  };

  return (
    <div
      className={`relative min-w-0 shrink-0 overflow-hidden transition-all duration-300 ease-in-out ${
        isCollapsed ? collapsedClassName : className
      }`}
    >
      {isCollapsed ? (
        <button
          type="button"
          aria-expanded="false"
          aria-label={`Open ${title} panel`}
          onClick={() => updateCollapsed(false)}
          className="flex h-full min-h-[64px] w-full items-center justify-center gap-2 border-l border-greyish border-opacity-10 bg-[#1b1b1b] px-2 py-4 text-greyish hover:text-white"
        >
          <FiChevronLeft className="text-lg" />
          <span className="hidden -rotate-90 whitespace-nowrap text-xs font-semibold uppercase tracking-wider md:block">
            {title}
          </span>
          <span className="text-xs font-semibold uppercase tracking-wider md:hidden">
            Show {title}
          </span>
        </button>
      ) : (
        <div className="h-full">
          <button
            type="button"
            aria-expanded="true"
            aria-label={`Collapse ${title} panel`}
            onClick={() => updateCollapsed(true)}
            className="absolute right-2 top-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-blackish text-greyish hover:text-white"
          >
            <FiChevronRight className="text-lg" />
          </button>
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleRightPanel;
